var swiper = new Swiper(".shop-by-categoryslider", {
        slidesPerView: 6.5,
        spaceBetween: 35,
        loop: false,
         pagination: {
          el: ".swiper-pagination",
           clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
       //  autoplay: {
       //      delay: 3000,
       //     disableOnInteraction: false, 
       // },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 5,
                autoplay: true
            },
            440: {
                slidesPerView: 3,
                spaceBetween: 5,
                autoplay: true
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 5,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 25
            }
        }
    });


var swiper = new Swiper(".happy-client", {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
           clickable: true,
        },
   navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        // },
       //  autoplay: {
       //      delay: 2000,
       //     disableOnInteraction: true, 
       // },
    
    });
/*
if ($('.product-recently-viewed__content').find('.product-recently-viewed-card').length === 0) {
  // Hide the entire recently viewed section
  $('.recently-viewed--section').hide();
}*/
document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.product-recently-viewed__content');
  const cards = content ? content.querySelectorAll('.product-recently-viewed-card') : [];

  if (cards.length === 0) {
    const section = document.querySelector('.recently-viewed--section');
    if (section) {
      section.style.display = 'none';
    }
  }
});




/* ======================= Calculator tool code start from here ======================= */
    var jquery = jQuery;

    



    jquery(document).ready(function () {


    /* === Helper: find outer product row (works with nested tables) === */
      function getProductRow($el) {
        if (!$el || $el.length === 0) return jquery();

        // start from the closest tr
        var $cur = $el.closest('tr');

        // climb up until we find a tr that contains a .product-title
        var safety = 0;
        while ($cur.length && $cur.find('.product-title').length === 0 && safety < 10) {
            $cur = $cur.parent().closest('tr');
            safety++;
        }

        // If not found, return the closest tr anyway
        return $cur.length ? $cur : $el.closest('tr');
    }

      /* --- Utility: parse weight safely --- */
       function readRowWeight($row) {
        $row = getOuterRow($row);
        var dataWeight = $row.find('.weight').data('weight');
        if (typeof dataWeight !== 'undefined' && dataWeight !== null && !isNaN(dataWeight)) {
          return parseFloat(dataWeight);
        }
        var text = ($row.find('.weight').text() || '').trim();
        if (!text) return 0;
        var clean = text.replace(/[^\d\-,.]/g, '').replace(',', '.');
        var n = parseFloat(clean);
        if (!isNaN(n)) return n >= 1000 ? n / 1000 : n;
        return 0;
      }

      /* --- Accordion toggle --- */
       jquery('.accordion-item-header').on('click', function () {
        var $parent = jquery(this).parent();
        var $content = jquery(this).next('.accordion-content');
        var isOpen = $parent.hasClass('active');
        jquery('.accordion-item').removeClass('active');
        jquery('.accordion-content').slideUp(180);
        if (!isOpen) {
          $parent.addClass('active');
          $content.slideDown(180);
        }
        setTimeout(function () {
          // only run assignFirstMaterialActive on outer rows inside this accordion
          var $outerRows = $parent.find('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
          $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
        }, 300);
    });


     function assignFirstMaterialActive($row) {
        $row = getOuterRow($row);
        var $materials = $row.find('.material-options .material');
        if ($materials.length === 0) return;
        if ($materials.filter('.active').length === 0) {
          $materials.removeClass('active');
          var $first = $materials.filter(function() {
            return jquery(this).text().trim() !== '';
          }).first();
          if ($first.length) $first.addClass('active');
        }
    }

      jquery('tr').each(function () {
    assignFirstMaterialActive(getProductRow(jquery(this)));
  });


        /* -----------------------
       Utility: get selected material safely
    ------------------------*/
    function getSelectedMaterial($row) {
    $row = getOuterRow($row);
    var $active = $row.find('.material-options button.active');
    if ($active.length) {
      return $active.data('material') !== undefined ? $active.data('material') : $active.text().trim();
    }
    var $first = $row.find('.material-options button').first();
    return $first.length ? ($first.data('material') !== undefined ? $first.data('material') : $first.text().trim()) : '-';
  }


    // ---------- Helper: find the outer row that contains .product-title ----------
        function findOuterRow(el) {
          var node = el;
          var steps = 0;
          while (node && node !== document && steps < 60) {
            try {
              if (node.querySelector && node.querySelector('.product-title')) {
                return $(node); // return jQuery object of the container that contains .product-title
              }
            } catch(e) { /* ignore odd nodes */ }
            node = node.parentNode;
            steps++;
          }
          // final fallback -> closest tr
          var $closestTr = $(el).closest('tr');
          return $closestTr.length ? $closestTr : $(el);
        }

      /* --- Zustand (Condition) default + click handling --- */
           function initZustandButtons() {
            jQuery(".zustand-options .condition").off("click").on("click", function () {
              let selectedCondition = jQuery(this).data("condition");

              let row = jQuery(this).closest("tr[data-selected-condition]").length 
                          ? jQuery(this).closest("tr[data-selected-condition]") 
                          : jQuery(this).closest("tr").parent().closest("tr");

              row.attr("data-selected-condition", selectedCondition);

              jQuery(this).siblings().removeClass("active");
              jQuery(this).addClass("active");

              console.log("Updated Condition:", selectedCondition);
            });
          }
           initZustandButtons();


      // Helper: get the outer product row (works with nested tables)
       function getOuterRow($el) {
        if (!$el || $el.length === 0) return jquery();
        var $cur = $el.closest('tr');
        var safety = 0;
        while ($cur.length && $cur.find('.product-title').length === 0 && safety < 30) {
          // climb upward: go to parent and find the next ancestor tr
          $cur = $cur.parent().closest('tr');
          safety++;
        }
        // if we found a tr that contains .product-title, return it, otherwise fallback to closest tr
        if ($cur.length && $cur.find('.product-title').length) return $cur;
        return $el.closest('tr');
      }

      // Zustand button click
     jQuery(document).on("click", ".zustand-options .condition:not([disabled])", function () {
        console.log('zustandTD');
          // Optional: check how many buttons exist
          console.log("Total buttons found:", jQuery(".zustand-options .condition").length);

          var $btn = jQuery(this); // clicked button
          var $wrapper = $btn.closest(".zustand-options"); // container of all buttons

          // Reset siblings
          $wrapper.find(".condition").removeClass("active").css("opacity", "0.7");

          // Activate clicked button
          $btn.addClass("active").css("opacity", "1");

          // Save selected condition to the row
          $btn.closest("tr.row_item").attr("data-selected-condition", $btn.data("condition"));
           updateSelection();

          console.log("BUTTON CLICKED:", $btn.data("condition"));
      });
     
  


      // CALL INIT ON PAGE LOAD
      // $(document).ready(function () {
      //   initZustandButtons();
      // });



      /* --- Material button toggles --- */
        jquery(document).on('click', '.material-options button', function () {
        var $btn = jquery(this);
        if ($btn.is(':disabled')) return;
        var $row = getOuterRow($btn);
        $row.find('.material-options button').removeClass('active');
        $btn.addClass('active');
        updateSelection();
      });


       /* ----------------------- When material button clicked ------------------------*/
    // jquery(document).on('click', '.material-options button', function () {
    //   var $btn = jquery(this);
    //   var $row = $btn.closest('tr');

    //   // toggle active state
    //   $btn.closest('.material-options').find('.material').removeClass('active');
    //   $btn.addClass('active');

    //   // update summary instantly if row is checked
    //   if ($row.find('.select-item').is(':checked')) {
    //     updateSelection();
    //   }
    // });

      // Quantity change
          jquery(document).on('input change', '.quantity', function () {
            var $row = getOuterRow(jquery(this));
            updateRowWeight($row);
            updateSelection();
          });

          // Checkbox change
          jquery(document).on('change', '.select-item', function () {
            var $row = getOuterRow(jquery(this));
            toggleButtonsState($row);
            updateSelection();
            setTimeout(function () {
              assignFirstMaterialActive($row);
              updateSelection();
            }, 0);
          });

          // scaff refresh event
          jquery(document).on('scaff:refreshMaterials', function (e, $scope) {
            var $context = $scope || jquery('table');
            var $outerRows = $context.find('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
            $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
            updateSelection();
          });

      /* --- Enable/disable Zustand + Material per row --- */
       function toggleButtonsState($row) {
        $row = getOuterRow($row);
        var isChecked = $row.find('.select-item').is(':checked');
        var $buttons = $row.find('.zustand-options button:not(.cursor-not-allowed), .material-options button, .quantity');
        if (isChecked) {
          $buttons.prop('disabled', false).css({ opacity: 1, pointerEvents: 'auto' });
          // ensure an active exists for Zustand
          if ($row.find('.zustand-options .condition.active').length === 0) {
            var $first = $row.find('.zustand-options .condition:not([disabled])').first();
            if ($first.length) {
              $first.addClass('active').css('opacity', '1');
              $row.attr('data-selected-condition', $first.data('condition'));
            }
          }
        } else {
          $buttons.prop('disabled', true).css({ opacity: 0.5, pointerEvents: 'none' });
          $row.find('.zustand-options .condition, .material-options button').removeClass('active').css('opacity', '0.7');
          $row.removeAttr('data-selected-condition');
        }
        toggleMainButtons();
      }

      // ---------- Toggle main action buttons ----------
      function toggleMainButtons() {
        var $mainButtons = jquery('.button-group button');
        var anyChecked = jquery('.select-item:checked').length > 0;
        $mainButtons.prop('disabled', !anyChecked);
      }

  // ---------- Update per-row total weight ----------
      function updateRowWeight($row) {
        $row = getOuterRow($row);
        var qty = parseFloat($row.find('.quantity').val()) || 1;
        var weightText = ($row.find('.weight').text() || '').replace(/[^\d.]/g, '');
        var weight = parseFloat(weightText) || 0;
        var subtotalWeight = weight * qty;
        $row.find('.total-weight').remove();
        $row.find('.weight').after('<div class="total-weight" style="display:none;"><span class="per-piece">' + weight.toFixed(1) + ' kg/Stück</span></div>');
      }

      /* --- Update summary sidebar --- */
    window.updateSelection = function () {
          jquery('.selected-items').remove(); // clear previous
          var totalCount = 0;
          var totalWeight = 0;
          var $selected = jquery('.select-item:checked');

          if ($selected.length === 0) {
            jquery('.no--items').show();
            jquery('#total-items').text(0);
            jquery('#total-weight').text('0.0');
            jquery('.summary-total, .info-box, .summary-right-main').hide();
            jquery('.next-step-btn, .reset-btn').prop('disabled', true).css({ opacity: 0.5 });
            return;
          } else {
            jquery('.no--items').hide();
            jquery('.summary-total, .info-box, .summary-right-main').show();
            jquery('.next-step-btn, .reset-btn').prop('disabled', false).css({ opacity: 1 });
          }

          $selected.each(function () {
            var $orig = jquery(this);
            var $row = getOuterRow($orig);
            var name = $row.find('.product-title').text().trim() || '-';
            var condition = $row.attr('data-selected-condition') || '-';
            var material = getSelectedMaterial($row) || '-';
            var qty = parseInt($row.find('.quantity').val(), 10) || 1;
            var weightPerUnit = readRowWeight($row);
            var subtotal = weightPerUnit * qty;
            console.log(JSON.stringify($row ));
           

            totalCount += qty;
            totalWeight += subtotal;

            var itemHTML = '<div class="selected-items"><div class="selected-row"><strong>' + jquery('<div>').text(name).html() + '</strong><br>' +
                          qty;
            if (condition !== "-" || material !== "-" ) itemHTML += '× ';
            if (condition !== "-" ) itemHTML += condition;
            if (condition !== "-" && material !== "-" ) itemHTML += ' • ';
            if (material !== "-" ) itemHTML += material;
            itemHTML += '<br><span class="per-piece">' + weightPerUnit.toFixed(1) + ' kg/Stück</span></div><div class="main-weight"><span class="per-piece">' + subtotal.toFixed(1) + 'kg</span></div></div>';

            jquery(itemHTML).insertBefore('.summary-total');
          });

          jquery('#total-items').text(totalCount);
          jquery('#total-weight').text(totalWeight.toFixed(1));
          toggleMainButtons();
  };

      /* --- Step navigation (single place) --- */
      // function goToStep(stepNumber) {
      //   // stepNumber: 1,2,3
      //   jquery('.steps li').removeClass('steps-active step-active'); // remove either class names you may use
      //   // mark only current step as active
      //   jquery('.steps li').eq(stepNumber - 1).addClass('steps-active step-round');



      //   // hide all containers then show the requested one
      //   jquery('.calculator-wrapper, .personal-info-container, .finish-container, .angebot-form').hide();
      //   if (stepNumber === 1) jquery('.calculator-wrapper').show();
      //   if (stepNumber === 2) jquery('.personal-info-container, .angebot-form').show();
      //   if (stepNumber === 3) jquery('.finish-container').show();
      // }



      function goToStep(stepNumber) {
          var $steps = jquery('.steps li');

          // Remove all active indicators
          $steps.removeClass('steps-active step-active');

          // Mark the current step as active
          $steps.eq(stepNumber - 1).addClass('steps-active');

          // --- Step-round progress indicator ---
          // Step 1 is always round
          $steps.removeClass('step-round');
          $steps.eq(0).addClass('step-round');

          // Add "step-round" to previous steps when user progresses
          if (stepNumber > 1) $steps.eq(1).addClass('step-round'); // Step 2 round after step 1 done
          if (stepNumber > 2) $steps.eq(2).addClass('step-round'); // Step 3 round after step 2 done

          // Hide all containers then show current one
          jquery('.calculator-wrapper, .personal-info-container, .finish-container, .angebot-form').hide();
          if (stepNumber === 1) jquery('.calculator-wrapper').show();
          if (stepNumber === 2) jquery('.personal-info-container, .angebot-form').show();
          if (stepNumber === 3) jquery('.finish-container').show();
        }

      /* --- Buttons that move between steps --- */
      // From Step 1 -> Step 2 (Next)
      jquery(document).on('click', '.next-step-btn, .next-btn', function (e) {
        e.preventDefault();
        saveSelectedItemsToStorage();
        goToStep(2);
      });

      // From Step 2 -> Step 1 (Back)
      jquery(document).on('click', '.back-btn', function (e) {
        e.preventDefault();
        goToStep(1);
      });

      // Optional: From Step 3 -> reload to Step 1 (as requested)
      // Use a dedicated button in step 3 with class .finish-next-btn
      jquery(document).on('click', '.finish-next-btn', function (e) {
        e.preventDefault();
        // full reload to reset everything (as you requested)
        location.reload();
      });

      /* --- Save selected items to localStorage --- */
       function saveSelectedItemsToStorage() {
        var selected = [];
        jquery('.select-item:checked').each(function () {
          var $row = getOuterRow(jquery(this));
          var name = $row.find('.product-title').text().trim() || '-';
          var condition = $row.attr('data-selected-condition') || '-';
          var material = getSelectedMaterial($row) || '-';
          var qty = parseInt($row.find('.quantity').val(), 10) || 1;
          var weightPerUnit = readRowWeight($row);
          var totalWeight = (weightPerUnit * qty).toFixed(1);
          selected.push({ name: name, condition: condition, material: material, qty: qty, weight: parseFloat(weightPerUnit.toFixed(1)), totalWeight: totalWeight });
        });
        localStorage.setItem('scaffold_items', JSON.stringify(selected));
      }

      /* --- Build Step 3 review (used after successful submit) --- */
      function buildStep3Review() {
        var items = JSON.parse(localStorage.getItem('scaffold_items') || '[]');
        var formData = JSON.parse(localStorage.getItem('scaffold_form') || '{}');

        jquery('.finish-container .info-grid').html(`
          <p><strong>Name:</strong> ${formData.name || '-'}</p>
          <p><strong>Firma:</strong> ${formData.firma || '-'}</p>
          <p><strong>E-Mail:</strong> ${formData.email || '-'}</p>
          <p><strong>Telefon:</strong> ${formData.telefon || '-'}</p>
          <p><strong>Lieferadresse:</strong> ${formData.adresse || '-'}</p>
          <p><strong>Nachricht / Zusatzinformationen:</strong> ${formData.nachricht || '-'}</p>
        `);
        jquery('#confirm-email').text(formData.email || '');

        var $productArea = jquery('.review-card').last();
        $productArea.empty();

        if (!items.length) {
          $productArea.append('<h4>Ihre Anfrage</h4><p>Keine Artikel ausgewählt.</p>');
          return;
        }

        var totalQty = 0;
        var totalWeight = 0;

        $productArea.append('<div class="review-title"><h4>Ihre Anfrage</h4></div>');
        // Create a wrapper div for the bottom info section
        var $infoWrapper = $('<div class="review-card-btm-info"></div>');
        items.forEach(function (item) {
          totalQty += item.qty;
          totalWeight += parseFloat(item.totalWeight);

          $infoWrapper.append(
            '<div class="item-line">' +
              '<div>' +
                '<strong>' + $('<div>').text(item.name).html() + '</strong><br>' +
                // item.qty + '× ' + item.condition + ' • ' + item.material + '<br>' +
                item.qty + '× ' + item.condition + '<br>' +
                '<span class="per-piece">' + parseFloat(item.weight).toFixed(1) + ' kg/Stück</span>' +
              '</div>' +
              '<div class="item-weight">' + item.totalWeight + ' kg</div>' +
            '</div>'
          );
        });

        $infoWrapper.append(
          '<div class="summary-totals">' +
            '<div class="summary-line"><span class="items-number"><span class="items-number-img"><img src="https://cdn.shopify.com/s/files/1/0730/7830/9186/files/items-number-icon.svg?v=1762507223" alt="items-number-icon"></span>Gesamtanzahl Artikel:</span><span><strong>' + totalQty + '</strong> Stück</span></div>' +
            '<div class="summary-line"><span class="items-number"><span class="items-number-img"><img src="https://cdn.shopify.com/s/files/1/0730/7830/9186/files/weight-icon.svg?v=1762507228" alt="weight-icon"></span>Gesamtgewicht:</span><span><strong>' + totalWeight.toFixed(1) + '</strong> kg</span></div>' +
          '</div>' +
          '<div class="status-box"><p><strong>Status:</strong> Ihr individuelles Angebot wird erstellt und in Kürze an Sie versendet.</p></div>'
        );

        // Finally append everything to the main review card container
          $productArea.append($infoWrapper);
      }



      /* --- Form submit (Step 2) — do NOT reload page --- */
      // Handles your angebot form submission; uses AJAX and then shows Step 3.
      jQuery(document).on('click', '.angebot_form_submit', function (e) {
         e.preventDefault();
          var $form = jQuery("#quoteForm");
          var formEl = $form[0];

        // HTML5 validation
        if (typeof formEl.checkValidity === 'function' && !formEl.checkValidity()) {
          formEl.reportValidity();
          return;
        }

        // Collect and save form to localStorage
        var formData = {
          name: jquery('#name').val() || '',
          firma: jquery('#firma').val() || '',
          email: jquery('#email').val() || '',
          telefon: jquery('#telefon').val() || '',
          adresse: jquery('#adresse').val() || '',
          nachricht: jquery('#nachricht').val() || ''
        };
        localStorage.setItem('scaffold_form', JSON.stringify(formData));

        // Build message (same as before)
        var message = "Anfrage Details:\n\n" +
          "Name: " + formData.name + "\n" +
          "Email: " + formData.email + "\n" +
          "Telefon: " + formData.telefon + "\n" +
          "Nachricht: " + formData.nachricht + "\n\n" +
          "Artikel:\n";

        var storedItems = JSON.parse(localStorage.getItem('scaffold_items') || '[]');
        if (storedItems.length) {
          message += storedItems.map(function(i) {
            return "- " + i.name + " (" + i.condition + ", " + i.material + ") x" + i.qty + " = " + i.totalWeight + "kg";
          }).join("\n");
        } else {
          message += "- Keine Artikel";
        }

        message += "\n\nGesamtanzahl: " + (storedItems.reduce(function (a, i) { return a + i.qty; }, 0)) +
                  "\nGesamtgewicht: " + (storedItems.reduce(function (a, i) { return a + parseFloat(i.totalWeight); }, 0)).toFixed(1) + " kg";

        console.log('message',message);
       jQuery('#contact_body').val(message);
       document.getElementById('quoteForm').submit();
        saveSelectedItemsToStorage();
        buildStep3Review();
        goToStep(3);

       /*
        var fd = new FormData();
        fd.append("form_type", "contact");
        fd.append("contact[name]", formData.name);
        fd.append("contact[email]", formData.email);
        fd.append("contact[phone]", formData.telefon);
        fd.append("contact[body]", message);

        // AJAX POST (keeps on same page)
        jquery.ajax({
          url: '/contact#contact_form',
          method: 'POST',
          data: fd,
          processData: false,
          contentType: false,
          success: function () {
            saveSelectedItemsToStorage(); // ensure items saved
            buildStep3Review();
            goToStep(3);
          },
          error: function () {
            // even on error, show step 3 so user sees confirmation
            saveSelectedItemsToStorage();
            buildStep3Review();
            goToStep(3);
          }
        });*/
      });

      /* --- Reset Button --- */
      jquery(document).on('click', '.reset-btn', function (e) {
        e.preventDefault();
        jquery('.select-item').prop('checked', false);
        jquery('.quantity').val(1);
        jquery('.zustand-options .condition, .material-options button').removeClass('active').css('opacity', '0.7');
        // re-init only outer rows
        var $outerRows = jquery('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
        $outerRows.each(function () { toggleButtonsState(jquery(this)); });
        updateSelection();
      });

      /* --- back-to-info (explicit reload if needed) --- */
      jquery(document).on('click', '.back-to-info', function (e) {
        e.preventDefault();
        location.reload();
      });

      /* --- Initialize UI on load --- */
      jquery('tr').each(function () { toggleButtonsState(getProductRow(jquery(this))); });
      initZustandButtons();


        // find only real product rows (those containing .product-title)
        var $outerRows = jquery('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });

        // run toggleButtonsState and assignFirstMaterialActive only on outer rows
        $outerRows.each(function () { toggleButtonsState(jquery(this)); });
        $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
        initZustandButtons($outerRows);

      // set first accordion open if exists
        var $firstAcc = jquery('.accordion-item').first();
        if ($firstAcc.length) {
          $firstAcc.addClass('active');
          $firstAcc.find('.accordion-content').show();
        }

      // default to step 1
      //goToStep(1);
      updateSelection();

      // expose for debugging if needed
      window.scaffUpdateSelection = updateSelection;

    });
/* ======================= Calculator tool code end here ============================== */


